/* istanbul ignore next */
const styles = ({ palette: { common, text }, spacing: { unit } }) => ({
  '@global': {
    "[id*='-splash']": {
      boxSizing: 'content-box'
    }
  },
  root: {
    alignItems: 'center',
    background: common.white,
    color: text.dark,
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    padding: 0,
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 1100
  },
  content: {
    padding: 10,
    textAlign: 'center'
  },
  buttons: {
    margin: -5,
    '&$buttons button.btn': {
      margin: 5,
      border: '3px solid #fff',
      boxShadow: '0 0 0 1px #000',
      textTransform: 'capitalize',
      padding: `${unit}px ${unit * 2.5}px`,
      borderRadius: unit
    }
  },
  container: {
    padding: unit * 5,
    display: 'flex',
    alignItems: 'center',
    height: '100vh',
    justifyContent: 'center',
    textAlign: 'center',
    '& .item-wrapper': {
      border: '2px solid #ccc',
      padding: unit * 5
    },
    ' & .title': {
      fontSize: '18px',
      fontWeight: 'bold',
      paddingBottom: unit * 1.5
    },
    '& button': {
      marginRight: unit * 1.5,
      marginTop: unit,
      textTransform: 'capitalize'
    }
  }
});

export default styles;
